import React from 'react';
import useLang from '../hooks/useLang';

const translations = {
  es: 'Programa con apoyo institucional',
  en: 'Program with institutional support'
};

export const KitDigitalBanner = () => {
  const lang = useLang();
  const text = translations[lang];

  return (
    <div
      className="w-full bg-white border-t border-b border-slate-200"
      data-testid="kit-digital-banner"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-5 sm:py-6">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <p className="text-[11px] sm:text-xs uppercase tracking-widest text-slate-500 font-semibold text-center sm:text-left">
            {text}
          </p>
          <img
            src="/banner-kitdigital.png"
            alt="Gobierno de España · Ministerio de Asuntos Económicos · Financiado por la Unión Europea NextGenerationEU · Plan de Recuperación, Transformación y Resiliencia"
            width={520}
            height={64}
            loading="lazy"
            decoding="async"
            className="h-14 sm:h-16 w-auto object-contain max-w-full"
          />
        </div>
      </div>
    </div>
  );
};

export default KitDigitalBanner;
